module.exports = __webpack_public_path__ + "static/media/no-administrator.946a539e.svg";